const eol = require("eol");
/* Takes plaintext with no formatting */
module.exports = function getShortestLine(text){
    return eol.split(text).sort((lineA, lineB)=>{
        return lineA.length - lineB.length;
    })[0];
}